/**
 * AngularJS FeatureFlagService
 * Bridge between Angular FeatureFlagService and AngularJS code
 * Allows legacy AngularJS code to access feature flags
 */

// This service will be registered with AngularJS and can be injected
// into controllers, services, and directives

(function () {
    "use strict";

    /**
     * FeatureFlagService for AngularJS
     * Provides access to Unleash feature flags from legacy code
     */
    angular.module("BannerFlowApp").factory("FeatureFlagService", [
        "$window",
        function ($window) {
            // Reference to the global Unleash client
            var unleashClient = null;

            /**
             * Initialize reference to Unleash client
             * The client is initialized by Angular app
             */
            function getUnleashClient() {
                if (!unleashClient && $window.unleashClientInstance) {
                    unleashClient = $window.unleashClientInstance;
                }
                return unleashClient;
            }

            /**
             * Check if a feature flag is enabled
             * @param {string} flagName - The name of the feature flag
             * @param {boolean} defaultValue - Default value if flag is not found
             * @returns {boolean} - Whether the flag is enabled
             */
            function isEnabled(flagName, defaultValue) {
                defaultValue = defaultValue !== undefined ? defaultValue : false;

                var client = getUnleashClient();
                if (!client) {
                    return defaultValue;
                }

                try {
                    return client.isEnabled(flagName);
                } catch (error) {
                    return defaultValue;
                }
            }

            /**
             * Get variant for a feature flag
             * @param {string} flagName - The name of the feature flag
             * @returns {object} - The variant object
             */
            function getVariant(flagName) {
                var client = getUnleashClient();
                if (!client) {
                    return { name: "disabled", enabled: false };
                }

                try {
                    return client.getVariant(flagName);
                } catch (error) {
                    return { name: "disabled", enabled: false };
                }
            }

            /**
             * Update context for feature flag evaluation
             * @param {object} context - Context object with userId, properties, etc.
             */
            function updateContext(context) {
                var client = getUnleashClient();
                if (!client) {
                    return;
                }

                try {
                    client.updateContext(context);
                } catch (error) {}
            }

            /**
             * Set a specific context field
             * @param {string} field - The field name
             * @param {string} value - The field value
             */
            function setContextField(field, value) {
                var client = getUnleashClient();
                if (!client) {
                    return;
                }

                try {
                    client.setContextField(field, value);
                } catch (error) {}
            }

            // Public API
            return {
                isEnabled: isEnabled,
                getVariant: getVariant,
                updateContext: updateContext,
                setContextField: setContextField
            };
        }
    ]);
})();
